import { CursorQuery, Paginated } from '../../common/pagination.js';
import { BlockState, BlockedUserView, ConnectInput, ConnectionQuery, ConnectionStateQuery, ConnectionRow, ConnectionStateView, SupportInput, UnsupportQuery, SupportState, SupporterQuery, SupporterRow, } from '../../network.js';
export const networkRoutes = {
    block: {
        method: 'POST',
        path: '/users/:userId/block',
        response: BlockState,
    },
    unblock: {
        method: 'DELETE',
        path: '/users/:userId/block',
        response: BlockState,
    },
    blockList: {
        method: 'GET',
        path: '/me/blocks',
        query: CursorQuery,
        response: Paginated(BlockedUserView),
    },
    connect: {
        method: 'POST',
        path: '/users/:userId/connection',
        /** Optional and defaulted — a bodyless POST is still a valid connect. */
        body: ConnectInput,
        response: ConnectionStateView,
    },
    /** Cancel own request, decline an incoming one, or remove a connection. */
    disconnect: {
        method: 'DELETE',
        path: '/users/:userId/connection',
        response: ConnectionStateView,
    },
    /** State plus the areas it was made under; `?areasOfInterest=` narrows it. */
    connectionState: {
        method: 'GET',
        path: '/users/:userId/connection',
        query: ConnectionStateQuery,
        response: ConnectionStateView,
    },
    connections: {
        method: 'GET',
        path: '/me/connections',
        query: ConnectionQuery,
        response: Paginated(ConnectionRow),
    },
    incomingRequests: {
        method: 'GET',
        path: '/me/connection-requests',
        query: ConnectionQuery,
        response: Paginated(ConnectionRow),
    },
    mutualConnections: {
        method: 'GET',
        path: '/users/:userId/mutual-connections',
        query: CursorQuery,
        response: Paginated(ConnectionRow),
    },
    support: {
        method: 'POST',
        path: '/users/:userId/support',
        body: SupportInput,
        response: SupportState,
    },
    /** Withdraw support for one area, or for all of them when none is named. */
    unsupport: {
        method: 'DELETE',
        path: '/users/:userId/support',
        query: UnsupportQuery,
        response: SupportState,
    },
    supporters: {
        method: 'GET',
        path: '/me/supporters',
        query: SupporterQuery,
        response: Paginated(SupporterRow),
    },
    supporting: {
        method: 'GET',
        path: '/me/supporting',
        query: SupporterQuery,
        response: Paginated(SupporterRow),
    },
    /**
     * The same two lists for SOMEONE ELSE, so a profile that is not your own can
     * show the faces behind its Supporters / Supporting counts rather than the
     * bare numbers. Same query and same row shape as the `/me` pair — the only
     * difference is whose list is being asked for, which is why these sit beside
     * `block`, `connection` and `mutual-connections` in the `/users/:userId`
     * namespace instead of bending `/me` to mean somebody else.
     */
    userSupporters: {
        method: 'GET',
        path: '/users/:userId/supporters',
        query: SupporterQuery,
        response: Paginated(SupporterRow),
    },
    userSupporting: {
        method: 'GET',
        path: '/users/:userId/supporting',
        query: SupporterQuery,
        response: Paginated(SupporterRow),
    },
};
//# sourceMappingURL=routes.js.map